import React, { useState } from 'react';
import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import ImprovedTaskTable from '../ImprovedTaskTable';
import { Button, useNexus, SearchInput } from '@spotoninc/nexus-react';
import { AddIcon, FilterIcon } from '@spotoninc/nexus-web-assets';
import '../../../../styles/reskinned-task-manager.css';
import {
  PRIORITY,
  STATUS,
  TASK_TYPE,
  useImprovedTaskManager,
} from './useImprovedTaskManager';
import ImprovedTaskForm from '../ImprovedTaskForm';
import TaskDrawer from '../TaskDrawer';
import OldTaskDrawer from '../TaskDrawer/OldTaskDrawer';
import NexusFilterDropdown from '../../../common/NexusFilterDropdown';
import { Pagination, IconButton } from '@spotoninc/nexus-react';
import MobileFiltersModal from './MobileFiltersModal';
import styles from './improvedTaskManager.module.css';

/**
 * This component will be the improved version of the reskinned task manager.
 * we are not used task drawer which is in dashboard as non reskinned verison
 * required that old drawer mapping
 *
 * Parent
 *      taskAdder
 */
function ImprovedTaskManager() {
  useNexus();

  const {
    // State
    isMobileFiltersOpen,
    tasks,
    users,
    loading,
    taskModal,
    selectedTask,
    isDrawerOpen,
    userOptions,
    filters,
    currentPage,
    locationData,
    selectedTaskVersion,
    totalPages,
    sort,

    // Functions
    fetchTasks,
    postFormSuccess,
    handleSort,
    handleDelete,
    handleEditClick,
    openTaskDrawer,
    closeTaskDrawer,
    handleUpdateFilter,
    handleSearch,
    handlePageChange,
    handleOldFetchTasks,
    handleOpenMobileFilters,
    handleCloseMobileFilters,

    // Modal functions
    openAddModal,
    closeTaskModal,
  } = useImprovedTaskManager();

  return (
    <div className="nexus-task-manager">
      <div className="nexus-task-page-header">
        <div className="nexus-task-title">
          {/* Hide the icon when showReskin is true */}
          {/* <ListViewIcon /> */}
          <Heading size={'lg'} className="reskinned-task-title">
            Tasks
          </Heading>
        </div>
        {/* <div className="nexus-task-header-actions">
          <Button
            onClick={openAddModal}
            leadingIcon={() => {
              return <AddIcon size={'1.5rem'} />;
            }}
          >
            Add Task
          </Button>
        </div> */}
      </div>
      <Flex direction={'row'} gap={2} justify={'space-between'}>
        <Flex items={'center'} gap={2} flex={1}>
          <SearchInput
            placeholder="Search keyword"
            onChange={handleSearch}
            className={styles.searchInput}
          />

          {/* Mobile Filter Button - Only visible on mobile */}
          <IconButton
            onClick={handleOpenMobileFilters}
            variant="ghost"
            className={`nexus-cancel-button ${styles.mobileFilterButton}`}
            icon={FilterIcon}
          />
        </Flex>

        {/* Desktop Filters - Hidden on mobile */}
        <Flex items={'center'} gap={2} className={styles.desktopFilters}>
          <NexusFilterDropdown
            label="Location"
            options={locationData}
            onChange={handleUpdateFilter('location')}
            value={
              filters['location']
                ? Array.isArray(filters['location'])
                  ? filters['location']
                  : [filters['location']]
                : undefined
            }
          />
          <NexusFilterDropdown
            label="Assigned To"
            options={userOptions}
            onChange={handleUpdateFilter('assigned_to')}
            value={
              filters['assigned_to']
                ? Array.isArray(filters['assigned_to'])
                  ? filters['assigned_to']
                  : [filters['assigned_to']]
                : undefined
            }
          />
          <NexusFilterDropdown
            label="Priority"
            options={PRIORITY}
            onChange={handleUpdateFilter('priority')}
            value={
              filters['priority']
                ? Array.isArray(filters['priority'])
                  ? filters['priority']
                  : [filters['priority']]
                : undefined
            }
          />
          <NexusFilterDropdown
            label="Status"
            options={STATUS}
            onChange={handleUpdateFilter('status')}
            value={
              filters['status']
                ? Array.isArray(filters['status'])
                  ? filters['status']
                  : [filters['status']]
                : undefined
            }
          />
          <NexusFilterDropdown
            label="Type"
            options={TASK_TYPE}
            onChange={handleUpdateFilter('task_type')}
            value={
              filters['task_type']
                ? Array.isArray(filters['task_type'])
                  ? filters['task_type']
                  : [filters['task_type']]
                : undefined
            }
          />
        </Flex>
      </Flex>

      <ImprovedTaskTable
        tasks={tasks}
        sort={sort}
        loading={loading}
        handleDelete={handleDelete}
        handleEditClick={handleEditClick}
        handleSort={handleSort}
        onRowClick={openTaskDrawer}
      />
      {tasks && tasks.length > 0 && (
        <Flex direction={'row'} justify={'center'}>
          <Pagination
            totalPages={totalPages}
            currentPage={currentPage}
            onChange={(_, page) => handlePageChange(page)}
          />
        </Flex>
      )}

      {/* Task Form - handles both add and edit */}
      {taskModal.show && (
        <ImprovedTaskForm
          isOpen={taskModal.show}
          onClose={closeTaskModal}
          onSuccess={postFormSuccess}
          selectedTask={taskModal.payload}
          users={users}
        />
      )}

      {/* Task Drawer */}

      <OldTaskDrawer
        selectedTask={selectedTask}
        isDrawerOpen={selectedTaskVersion === '1' && isDrawerOpen}
        onClose={closeTaskDrawer}
        modifyTasks={data => {}} // Will be implemented later
        fetchTasks={handleOldFetchTasks} // Will be implemented later
        isFromTaskTable={false}
      />

      <TaskDrawer
        selectedTask={selectedTask}
        isDrawerOpen={selectedTaskVersion === '2' && isDrawerOpen}
        onClose={closeTaskDrawer}
        modifyTasks={data => {}} // Will be implemented later
        fetchTasks={() => {
          fetchTasks({ filters, page: currentPage, sort });
        }} // Will be implemented later
        isFromTaskTable={true}
      />

      {/* Mobile Filters Modal */}
      {isMobileFiltersOpen && (
        <MobileFiltersModal
          isOpen={isMobileFiltersOpen}
          onClose={handleCloseMobileFilters}
          filters={filters}
          handleUpdateFilter={handleUpdateFilter}
          locationData={locationData}
          userOptions={userOptions}
        />
      )}
    </div>
  );
}

export default React.memo(ImprovedTaskManager);
